import { createSlice} from "@reduxjs/toolkit";

const initialState = {
    current_coors: {},
};

export const MapPositionSlice = createSlice({
    name: 'mapPosition',
    initialState:initialState,
    reducers: {
        saveDataLatLon: (state, action) => {
            state.current_coors = action.payload
        },
    },
});


export const {saveDataLatLon} = MapPositionSlice.actions;
export default MapPositionSlice.reducer